import { render, staticRenderFns } from "./eventView.vue?vue&type=template&id=3c3c2947&scoped=true"
import script from "./eventView.vue?vue&type=script&lang=js"
export * from "./eventView.vue?vue&type=script&lang=js"
import style0 from "./eventView.vue?vue&type=style&index=0&id=3c3c2947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3c2947",
  null
  
)

export default component.exports